module.exports = __webpack_public_path__ + "static/media/T_Rosalia_Fernandez_San_Agustin.51712074.jpg";